/* eslint-disable react-hooks/immutability */
// import { RedirectToLogin } from '~/auth';
import axios from 'axios';
import UserService from '~/auth/UserService';

const query = axios.create({
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
  },
});

const workspaceQuery = axios.create({
  baseURL: import.meta.env.VITE_APP_WORKSPACE_API,
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
  },
});

const dataDictionaryQuery = axios.create({
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
  },
});

export function setQueryBaseURLs({ baseDemandAPI, baseDataDictionaryAPI }) {
  if (baseDemandAPI) query.defaults.baseURL = baseDemandAPI;
  if (baseDataDictionaryAPI) dataDictionaryQuery.defaults.baseURL = baseDataDictionaryAPI;
}

function handleUnauthorized(error) {
  if (error?.response?.status === 401) return UserService.doLogout();
  return Promise.reject(error);
}

let interceptorsRegistered = false;
function registerInterceptorsOnce() {
  if (interceptorsRegistered) return;
  interceptorsRegistered = true;

  query.interceptors.response.use(response => response, handleUnauthorized);
  workspaceQuery.interceptors.response.use(response => response, handleUnauthorized);
}

export default function useQueryAgent() {
  const token = UserService.getToken();
  query.defaults.headers.Authorization = `Bearer ${token}`;
  workspaceQuery.defaults.headers.Authorization = `Bearer ${token}`;
  dataDictionaryQuery.defaults.headers.Authorization = `Bearer ${token}`;

  registerInterceptorsOnce();

  return {
    get: ([apiName, data]) => query.get(apiName, { params: { ...(data || {}) } }),
    getWorkspace: (apiName, data) => workspaceQuery.get(apiName, { params: { ...(data || {}) } }),
    fetchDataDictionary: ([apiName, data]) =>
      dataDictionaryQuery.get(apiName, { params: { ...(data || {}) } }),
  };
}
